import React, { Component } from 'react'

import Img from 'gatsby-image'

import Authored from '../Authored/index'

import './style.scss'
import { Link } from 'gatsby'

import { ReactComponent as Arrow } from '../../gfx/button-next.svg'

import Tags from '../Tags'

export default class ArticleTeaser extends Component {
  render() {
    const { mini } = this.props
    const {
      fields: { slug },
      frontmatter: {
        title,
        date,
        thumbnail_image: cover,
        category,
        author,
        tags,
        author_avatar: avatar,
      },
      excerpt,
    } = this.props.data

    const vSpacing = mini ? 'my-2' : 'my-3'

    return (
      <Link className="text-dark" to={slug}>
        <article
          className={`c-article-teaser bg-white ${
            mini ? 'p-2 p-sm-3 c-article-teaser--small pb-3' : 'p-2 p-sm-4 pb-4'
          }`}
        >
          <h6>{category}</h6>
          <h2 className={vSpacing}>{title}</h2>
          <Img fluid={cover.childImageSharp.fluid} />
          <div className={vSpacing}>
            <Authored mini={mini} author={author} avatar={avatar} date={date} />
          </div>
          {!mini && (
            <>
              <div>{excerpt}</div>
              {tags && (
                <div className="mt-3 d-none d-sm-block">
                  <Tags data={tags.slice(0, 4)} />
                </div>
              )}
            </>
          )}

          <span
            className={`c-article-teaser__arrow ${
              mini ? 'mr-sm-3' : 'mr-sm-4'
            }`}
            to={slug}
          >
            <Arrow />
          </span>
        </article>
      </Link>
    )
  }
}
